export const REFERRAL_CODE = '_toggle_referral';
export const PROMO_CODE = '_toggle_promo';
